var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.isClose)?_c('div',{staticClass:"message-content color-fff fs20 fw600"},[_c('div',{staticClass:"text"},[_vm._v("请手机竖向锁定后横置体验")])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }